export const uploadPending = (state) => state.mile.uploadLoading;
export const uploadError = (state) => state.mile.uploadError;

export const uploadHistoryData = (state) => state.mile.uploadHistory;
export const uploadHistoryStatus = (state) => state.mile.uploadHistoryStatus;
export const uploadHistoryError = (state) => state.mile.uploadHistoryError;

export const uploadProgressLoading = (state) => state.mile.uploadProgressLoading;
export const uploadProgressError = (state) => state.mile.uploadProgressError;
